import React from 'react'
import { TbArrowBigLeftFilled } from "react-icons/tb"
import { Container } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Button from 'react-bootstrap/Button';
import { useState, useEffect } from 'react';
import { gsap } from 'gsap';
import { useHistory } from 'react-router-dom';
import firebase from 'firebase/compat/app';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './Firebase/Firebase';
import { BsPlusSquareDotted } from "react-icons/bs"
import { Watch } from 'react-loader-spinner';
import 'react-quill/dist/quill.snow.css';
import "./CreatePost.scss"
import Select from 'react-select';


function UploadProject() {
    useEffect(() => {
        return () => {
            gsap.to(".App", { duration: .0, css: { visibility: 'visible' } })
        };
    }, []);
    const [Title, setTitle] = useState('');
    const [Client, setClient] = useState('');
    const [Background, setBackground] = useState('');
    const [Duration, setDuration] = useState('');
    const [ImageID, setImageID] = useState('');
    const [Objective, setObjective] = useState('');
    const [Results, setResults] = useState('');
    const [Revisions, setRevisions] = useState('');
    const [Solutions, setSolutions] = useState('');
    const [Challenges, setChallenges] = useState('');
    const [Time, setTime] = useState('');
    const [Tools, setTools] = useState([]);
    const [Year, setYear] = useState('');
    const [Detail, setDetail] = useState('');
    const [photo, setPhoto] = useState(null); // Store the selected photo
    const [PhotoUrl, setPhotoUrl] = useState('');
    const [Label, setLabel] = useState('');
    const [LinkUrl, setLinkUrl] = useState('');
    const history = useHistory();
    const [folderName, setFolderName] = useState('');
    const [uploading, setUploading] = useState(false); // To track if an image is uploading

    const [projectImages, setProjectImages] = useState([]);
    const [imagePreviews, setImagePreviews] = useState([]);



    const labels = [
        { id: 1, name: 'UI' },
        { id: 2, name: '3D' },
        { id: 3, name: 'Branding' },
        { id: 4, name: 'Poster' },
        { id: 5, name: 'Video' },
        { id: 6, name: 'Flyer' },
        { id: 7, name: 'Product Design' },
        { id: 8, name: 'T-Shirt Design' },
        { id: 9, name: 'Website' },
        { id: 10, name: 'Wireframe' },
    ];

    const tools = [
        { id: 1, name: 'Figma' },
        { id: 2, name: 'Adobe XD' },
        { id: 3, name: 'Photoshop' },
        { id: 4, name: 'Illustrator' },
        { id: 5, name: 'After Effects' },
        { id: 6, name: 'Premiere Pro' },
        { id: 7, name: 'InDesign' },
        { id: 8, name: 'Blender' },
        { id: 9, name: 'Cinema 4D' },
        { id: 10, name: 'Sketch' },
        { id: 11, name: 'Webflow' },
        { id: 12, name: 'WordPress' },
        { id: 13, name: 'HTML/CSS' },
        { id: 14, name: 'JavaScript' },
        { id: 15, name: 'React' },
        { id: 16, name: 'Python' },
        { id: 17, name: 'Firebase' },
    ];

    const toolOptions = tools.map((tool) => ({
        value: tool.name,
        label: tool.name,
    }));

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 15 }, (_, i) => currentYear - i); // last 15 years


    const handleGoBack = () => {
        history.goBack(); // This will go back to the previous page
    };


    const handleImageChange = async (e) => {
        if (e.target.files[0]) {
            const selectedImage = e.target.files[0];
            // Define the minimum and maximum allowed dimensions
            const minWidth = 240;
            const maxWidth = 4000;
            const minHeight = 224;
            const maxHeight = 4000;

            const img = new Image();
            img.src = URL.createObjectURL(selectedImage);

            img.onload = () => {
                const imageWidth = img.width;
                const imageHeight = img.height;

                if (
                    imageWidth < minWidth ||
                    imageWidth > maxWidth ||
                    imageHeight < minHeight ||
                    imageHeight > maxHeight
                ) {
                    // Image dimensions are outside the allowed range
                    alert(
                        `Please select an image with dimensions between ${minWidth}x${minHeight} and ${maxWidth}x${maxHeight} pixels.`
                    );
                    // Reset the file input to clear the selection
                    e.target.value = '';
                } else {
                    setPhoto(selectedImage);
                    setPhotoUrl(URL.createObjectURL(selectedImage));
                }
            };
        }
    };

    const handleMultipleImages = (e) => {
        const files = Array.from(e.target.files);
        const newPreviews = files.map(file => URL.createObjectURL(file));

        setProjectImages(prev => [...prev, ...files]);
        setImagePreviews(prev => [...prev, ...newPreviews]);
    };

    const handleRemoveImage = (index) => {
        setProjectImages((prev) => prev.filter((_, i) => i !== index));
        setImagePreviews((prev) => prev.filter((_, i) => i !== index));
    };

    useEffect(() => {
        const generateImageID = async () => {
            if (!Title || !Label) return;

            const snapshot = await firebase.firestore().collection('Portfolio').get();
            let max = 0;

            snapshot.forEach(doc => {
                const id = doc.data().ImageID;
                if (id && id.startsWith('RM')) {
                    const num = parseInt(id.slice(2), 10);
                    if (!isNaN(num)) max = Math.max(max, num);
                }
            });

            const newImageNumber = max + 1;
            const paddedID = `RM${String(newImageNumber).padStart(5, '0')}`;
            setImageID(paddedID);

            const safeTitle = Title.trim().replace(/\s+/g, '-').toLowerCase();
            const folder = `${safeTitle}-${paddedID}`;
            setFolderName(folder);
        };

        generateImageID();
    }, [Title, Label]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!photo || !Title || !Label || !ImageID) {
            alert('Please provide a Title, label, photo, and ensure ImageID is generated.');
            return;
        }

        setUploading(true);
        try {

            const safeLabel = Label.trim().replace(/\s+/g, '-').toLowerCase(); // Used for folder path
            const safeTitleID = Title.trim().replace(/\s+/g, '-').toLowerCase(); // Used for Firestore doc ID
            const imageRef = ref(storage, `/Images/${safeLabel}/${folderName}/${photo.name}`);
            const uploadSnap = await uploadBytes(imageRef, photo);
            const photoURL = await getDownloadURL(uploadSnap.ref);
            setPhotoUrl(photoURL);

            // 4. Upload metadata to Firestore
            const startTimestamp = new Date(Time);


            const postRef = firebase.firestore().collection('Portfolio').doc(safeTitleID);
            await postRef.set({
                postId: safeTitleID,
                Title,
                PhotoUrl: photoURL,
                Label,
                Client,
                Background,
                Duration,
                ImageID: ImageID,
                Objective,
                Results,
                Revisions,
                Solutions,
                Tools: Tools.join(', '), // 🔥 convert to "Figma, Photoshop, Blender",
                Year,
                Detail,
                Challenges,
                LinkUrl,
                Time: startTimestamp,
            });

            // 🔻 Upload each image in projectImages to subcollection "Images"
            const imagesCollectionRef = postRef.collection('Images');

            for (let i = 0; i < projectImages.length; i++) {
                const file = projectImages[i];
                const imgRef = ref(storage, `/Images/${safeLabel}/${folderName}/extras/${file.name}`);
                const imgSnap = await uploadBytes(imgRef, file);
                const imgUrl = await getDownloadURL(imgSnap.ref);

                await imagesCollectionRef.doc(`Image${i + 1}`).set({
                    Url: imgUrl,
                });
            }

            alert('Upload successful');
            console.log('Project uploaded successfully!');
            setUploading(false);

            // 5. Reset form
            setProjectImages([]);
            setImagePreviews([]);
            setTitle('');
            setPhoto(null);
            setDetail('');
            setBackground('');
            setLabel('');
            setClient('');
            setDuration('');
            setImageID('');
            setObjective('');
            setResults('');
            setRevisions('');
            setSolutions('');
            setTime('');
            setTools('');
            setYear('');
            setChallenges('');
            setLinkUrl('');

            window.open('/portfolio', '_blank'); // opens in new tab
            window.location.reload(); // reloads current tab

        } catch (error) {
            console.error('Error uploading project:', error);
            alert('Failed to upload project.');
            setUploading(false);
        }
    };


    return (
        <div>
            <div className="navigating">
                <div className="arrow">
                    <TbArrowBigLeftFilled onClick={handleGoBack} />
                </div>
                <div className="BrandCreate">
                    <h4>mete & design.</h4>
                </div>
            </div>

            <section className='FormSect'>
                <Container className='FormSectCont'>
                    <h2>New Project</h2>
                    <div className="forming2">
                        <Form onSubmit={handleSubmit}>
                            <fieldset disabled={uploading}>
                                <Row>
                                    <Col className="fussion">
                                        <Form.Group className='formJy'>
                                            <div className="imager2">

                                                <div className="uploading">
                                                    {uploading ? (
                                                        <div className="uploading">
                                                            <Watch color="#121212" width="40px" ariaLabel="watch-loading" className="watchSpn" radius="48" data-testid="loader" />
                                                        </div>
                                                    ) : (
                                                        <>
                                                            {PhotoUrl ? (
                                                                <label htmlFor="imageInput" className="plusup2">
                                                                    <img src={PhotoUrl} alt="Selected" />
                                                                </label>
                                                            ) : (
                                                                <>
                                                                    <div className="uploading">
                                                                        {/* BsPlusSquareDotted icon will only be shown when no image is selected */}
                                                                        <label htmlFor="imageInput" className="plusup">
                                                                            <BsPlusSquareDotted className='doty' />
                                                                        </label>
                                                                    </div>
                                                                    <input id="imageInput" type="file" accept="image/*" className="picUploader visually-hidden" onChange={handleImageChange} />
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </div>

                                            </div>
                                            <div className='inpu'>
                                                <Form.Control type='file' accept='image/*' className='picUploader' onChange={handleImageChange}></Form.Control>
                                            </div>

                                        </Form.Group>
                                        {/* for title */}
                                        <Form.Group className="mb-3" controlId="formGroupHeading">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Title"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Control type="text" placeholder='Title' required
                                                    value={Title}
                                                    onChange={(e) => setTitle(e.target.value)} />
                                            </FloatingLabel>

                                        </Form.Group>

                                        {/* for label */}
                                        <Form.Group className="mb-3" controlId="formGroupLabel">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Label"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Select aria-label="Default select example" required as='select'
                                                    value={Label} onChange={(e) => setLabel(e.target.value)}
                                                >
                                                    <option value="">Select Label</option>
                                                    {labels.map((labelOption) => (
                                                        <option key={labelOption.id} value={labelOption.name}>{labelOption.name}</option>
                                                    ))}

                                                </Form.Select>
                                            </FloatingLabel>
                                        </Form.Group>

                                        {/* for Client */}
                                        <Form.Group className="mb-3" controlId="formGroupHeading">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Client"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Control type="text" placeholder='Client' required
                                                    value={Client}
                                                    onChange={(e) => setClient(e.target.value)} />
                                            </FloatingLabel>

                                        </Form.Group>

                                        {/* for Background */}
                                        <Form.Group className="mb-3" controlId="formGroupHeading">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Client Background"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Control type="text" placeholder='Client Background' required
                                                    value={Background}
                                                    onChange={(e) => setBackground(e.target.value)} />
                                            </FloatingLabel>

                                        </Form.Group>

                                        {/* for Duration */}
                                        <Form.Group className="mb-3" controlId="formGroupHeading">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Duration"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Control type="text" placeholder='Duration' required
                                                    value={Duration}
                                                    onChange={(e) => setDuration(e.target.value)} />
                                            </FloatingLabel>

                                        </Form.Group>

                                        {/* for ImageID */}
                                        {ImageID && (
                                            <Form.Group className="mb-3">
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Image ID"
                                                    className="mb-3 bg-transparent text-dark"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        value={ImageID}
                                                        readOnly

                                                    />
                                                </FloatingLabel>
                                            </Form.Group>
                                        )}

                                        {/* for Objective */}
                                        <Form.Group className="mb-3" controlId="formGroupHeading">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Objective"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Control type="text" placeholder='Objective' required
                                                    value={Objective}
                                                    onChange={(e) => setObjective(e.target.value)} />
                                            </FloatingLabel>

                                        </Form.Group>

                                        {/* for results */}
                                        <Form.Group className="mb-3" controlId="formGroupHeading">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Results"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Control type="text" placeholder='Results' required
                                                    value={Results}
                                                    onChange={(e) => setResults(e.target.value)} />
                                            </FloatingLabel>

                                        </Form.Group>

                                        {/* for Revisions */}
                                        <Form.Group className="mb-3" controlId="formGroupHeading">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Revisions"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Control type="text" placeholder='Revisions' required
                                                    value={Revisions}
                                                    onChange={(e) => setRevisions(e.target.value)} />
                                            </FloatingLabel>

                                        </Form.Group>

                                        {/* for Challenges */}
                                        <Form.Group className="mb-3" controlId="formGroupHeading">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Challenges"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Control type="text" placeholder='Challenges' required
                                                    value={Challenges}
                                                    onChange={(e) => setChallenges(e.target.value)} />
                                            </FloatingLabel>

                                        </Form.Group>

                                        {/* for Solutions */}
                                        <Form.Group className="mb-3" controlId="formGroupHeading">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Solutions"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Control type="text" placeholder='Solutions' required
                                                    value={Solutions}
                                                    onChange={(e) => setSolutions(e.target.value)} />
                                            </FloatingLabel>

                                        </Form.Group>

                                        {/* for time */}
                                        <Form.Group className="mb-3" controlId="formGroupHeading">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Time"
                                                className="mb-3 bg-transparent text-dark"
                                            >

                                                <Form.Control type="datetime-local" placeholder='Time' required
                                                    value={Time}
                                                    onChange={(e) => setTime(e.target.value)} />

                                            </FloatingLabel>
                                        </Form.Group>

                                        {/* for Tools */}
                                        <Form.Group className="mb-3" controlId="formGroupHeading">

                                            <Select
                                                isMulti
                                                name="tools"
                                                options={toolOptions}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                value={Tools.map((tool) => ({ label: tool, value: tool }))}
                                                onChange={(selectedOptions) =>
                                                    setTools(selectedOptions.map((opt) => opt.value))
                                                }
                                                isDisabled={uploading}
                                            />


                                        </Form.Group>

                                        {/* for Year */}
                                        <Form.Group className="mb-3" controlId="formGroupYear">
                                            <FloatingLabel
                                                controlId="floatingSelectYear"
                                                label="Year"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Select
                                                    value={Year}
                                                    onChange={(e) => setYear(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select Year</option>
                                                    {years.map((year) => (
                                                        <option key={year} value={year}>{year}</option>
                                                    ))}
                                                </Form.Select>
                                            </FloatingLabel>
                                        </Form.Group>

                                        {/* for linkurl */}
                                        <Form.Group className="mb-3" controlId="formGroupYear">
                                            <FloatingLabel
                                                controlId="floatingSelectYear"
                                                label="Link URL"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Control type="text" placeholder='Link URL'
                                                    value={LinkUrl}
                                                    onChange={(e) => setLinkUrl(e.target.value)} />
                                            </FloatingLabel>
                                        </Form.Group>


                                        {/* for Content */}
                                        <Form.Group className="mb-3" controlId="formGroupEditor">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Detail"
                                                className="mb-3 bg-transparent text-dark"
                                            >
                                                <Form.Control

                                                    className='textArea2'
                                                    as="textarea"
                                                    required
                                                    value={Detail}
                                                    type="text" placeholder='Detail'

                                                    onChange={(e) => setDetail(e.target.value)}

                                                />
                                            </FloatingLabel>

                                        </Form.Group>

                                        <Form.Group>
                                            <div className="multiple-image-upload-section">
                                                <label className="multi-upload-label">Upload more images:</label>
                                                <div className="uploading">

                                                    <div className='inpu'>
                                                        <Form.Control
                                                            as="input"
                                                            type="file"
                                                            accept="image/*"
                                                            multiple
                                                            onChange={handleMultipleImages}
                                                            className="multi-image-input picUploader "
                                                        />

                                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: '10px', marginTop: '20px' }}>
                                                            {imagePreviews.map((src, index) => (
                                                                <div key={index} className="image-preview">
                                                                    <img src={src} alt={`Preview ${index + 1}`} style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
                                                                    <button
                                                                        onClick={() => handleRemoveImage(index)}
                                                                        className="delete-button"
                                                                    >
                                                                        &times;
                                                                    </button>
                                                                </div>
                                                            ))}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>


                                        <Button type="submit" className='PostBtn' disabled={uploading}>{uploading ? "Uploading..." : "Post"}</Button>
                                        <div className="padIt">
                                            <Form.Text className='tips'>
                                                <p><strong>Tips: 1.</strong>  Select a label from the list of labels that best describes your post. </p>
                                                <p> <strong>2.</strong> You can add photos and videos in your post from the text editor.
                                                </p>
                                            </Form.Text>
                                        </div>

                                    </Col>



                                </Row>
                            </fieldset>
                        </Form>
                    </div>

                </Container>
            </section>
        </div>
    )
}

export default UploadProject